import {call, put, takeEvery} from 'redux-saga/effects';

import Api from '../lib/Api';

import {
  fetchOrdersSucceeded,
  fetchOrdersFailed, updateOrder
} from '../store/orders/actions';
import {CANCEL_ORDER, FETCH_ORDERS_REQUESTED, VERIFY_ORDER} from '../store/orders/actionTypes';

const _getOrdersRequested = () => {
    return Api.getOrdersList()
        .then((response) => response)
        .catch((e) => e.response);
};

const _postOrderCancelRequested = ({id}) => {
    console.log('>>>',id);
    return Api.postСancelOrder({id})
        .then((response) => response)
        .catch((e) => e.response);
};

const _postOrderVerifyRequested = ({id}) => {
    console.log('>>>',id);
    return Api.postVerifyOrder({id})
        .then((response) => response)
        .catch((e) => e.response);
};

function* fetchOrders() {
    try {
        const response = yield call(_getOrdersRequested);
        yield put(fetchOrdersSucceeded({orders: response.data.data}));
    } catch (error) {
        yield put(fetchOrdersFailed(error));
    }
}

function* fetchVerifyOrders(action) {
    try {
        const response = yield call(_postOrderVerifyRequested, action.payload);
        yield put(updateOrder({order: response.data.data}));
    } catch (error) {
        yield put(fetchOrdersFailed(error));
    }
}

function* fetchCancelOrders(action) {
    try {
        const response = yield call(_postOrderCancelRequested, action.payload);
        yield put(updateOrder({order: response.data.data}));
    } catch (error) {
        yield put(fetchOrdersFailed(error));
    }
}

function* OrdersSaga() {
    yield takeEvery(FETCH_ORDERS_REQUESTED, fetchOrders);
    yield takeEvery(VERIFY_ORDER, fetchVerifyOrders);
    yield takeEvery(CANCEL_ORDER, fetchCancelOrders);
}

export default OrdersSaga;



// WEBPACK FOOTER //
// ./src/saga/orders.js